import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=f2ccfef8&scoped=true&"
import script from "./Payment.vue?vue&type=script&lang=js&"
export * from "./Payment.vue?vue&type=script&lang=js&"
import style0 from "./Payment.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Payment.vue?vue&type=style&index=1&id=f2ccfef8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ccfef8",
  null
  
)

export default component.exports